import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Currency extends BaseEntity{
    
    currencyCode    : string;
    name            : string;
    theRate         : number;
    lastUpdate      : Date;
    rank            : number;
}
